import { render, staticRenderFns } from "./DataLogList.vue?vue&type=template&id=52d3b5f8&scoped=true&"
import script from "./DataLogList.vue?vue&type=script&lang=js&"
export * from "./DataLogList.vue?vue&type=script&lang=js&"
import style0 from "./DataLogList.vue?vue&type=style&index=0&id=52d3b5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d3b5f8",
  null
  
)

export default component.exports